<template>
    <div
        class="relative flex flex-col rounded-xl bg-gray-50 border m-6 bg-clip-border text-gray-700 shadow-md w-full sm:w-3/4 md:w-1/2 lg:w-1/3 xl:w-1/4">
        <div
            class="relative mx-4 -mt-6 h-full overflow-hidden rounded-xl bg-blue-gray-500 bg-clip-border text-white shadow-lg shadow-blue-gray-500/40 bg-gradient-to-r from-orange-500 to-orange-600">
            <img class="object-contain  w-fit" :src="imgUrl" alt="Sunset in the mountains">
        </div>
        <div class="p-6">
            <h5
                class="mb-2 block font-sans text-xl font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased">
                {{ title }}
            </h5>
            <p class="block font-sans text-base font-light leading-relaxed text-inherit antialiased">
                {{ breed }}
            </p>
        </div>
        <div class="p-6 pt-0">
            <router-link to="/adopt"
                class="select-none rounded-lg bg-orange-500 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-orange-500/20 transition-all hover:shadow-lg hover:shadow-orange-500/40 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none">
                See More
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeProductCard',
    props: {
        imgUrl: String,
        title: String,
        breed: String,
    },
    data() {
        return {
        }
    }
};
</script>

<style scoped></style>
